<template>
  <div>
  <div v-if="cabin" class="flexcabin midblock hoverme"    v-on:click="doClick(cabin)" style="position: relative">

    <div style="width:20%;overflow-y:hidden" class="hidemobileimage">
      <div  class="cabin-banner-chosen">
        Meest gekozen
      </div>
      <div class="cabin_section">
        <div
            class="cabin_images width100"
            style="position: relative;"
        >
          <div
              v-on:click="toggleFloorPlan()"
              class="view_map_button"
              style=""
          >
            <font-awesome-icon icon="map"/>
          </div>
          <img
              class="width100 cabin-image resize-image"
              :src="returnCorrectImage()"
          />
        </div>
      </div>
    </div>
    <div style="width:40%;padding-left:10px;display: flex;" class="flexmobile-wrap">
    <div style="width:100%;font-size:16px;padding-top:20px;max-height: initial">
      <b >Laat ons de {{ cabin.type.toLowerCase() }} kiezen</b><br>
      <span style="font-size:12px;">
     We zullen de meest voordelige en best beschikbare {{ cabin.type.toLowerCase()}} kiezen. Zo hoef je zelf niet na te denken over de ligging en locatie.
     </span>
    </div>



    </div>
    <div style="width:40%;display: flex;">
      <div style="width:50%;display: flex;flex-flow:column;justify-content: center;">
        <span
            v-if="cabin.apiData && cabin.apiData.prijs"
        >
                        <h2 class="darkblue bold" style="font-weight: normal;font-size:16px;text-align: center !important;width:100%;">
                            €
                            {{
                            roundPrice(
                                cabin.apiData.prijs /
                                payload.cabins[0].volwassenen,
                            )
                          }}
                            <small v-if="payload.cabins[0].volwassenen > 1"
                            >p.p.</small
                            >
                        </h2>
                    </span>
      </div>
      <div style="width:50%;display: flex;flex-flow:column;justify-content: center;">
        <div v-if="canSelect(cabin) && cabin.apiData.prijs" style="width:90%;margin-top:-10px;">
          <button
              v-on:click="doClick(cabin)"
              type="button"
              :id="'testCabinSelect' + index"
              class="btn btn-success btn-addon width100 font14 bold floatleft margintop10"
          >
            Selecteer <font-awesome-icon icon="angle-right" />
          </button>
          <br/>
        </div>
      </div>
    </div>
  </div>

    <div style="width:100%; margin-top: 30px;margin-bottom:20px; text-align: center;font-size:16px; background-image: linear-gradient(transparent, transparent 49%, black 49%, transparent 53%);">
      <span style="background: #f8f8f8; padding-inline: 10px;">Of kies zelf je hut</span>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheck,
    faExclamation,
    faInfo,
    faMap,
    faMinus,
    faPlus,
    faSpinner,
    faTimes,
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheck)
library.add(faSpinner)
library.add(faMap)
library.add(faInfo)
library.add(faExclamation)
library.add(faPlus)
library.add(faMinus)
library.add(faTimes)

export default {
    name: 'CheapestCabinAvailabilityResult',
    props: {
        cabin: Object,
        index: Number,
        payload: Object,
        cruise: Object,
        isSelected: Boolean,
        availabilityReceived: Boolean,
        deckNames: Object,
        numberWithCommas: Function,
        roundPrice: Function,
        cabinName: Function,
        ajaxCalls: Number,
        findRateName: Function,
    },
    data: function() {
        return {
            floorPlanVisible: false,
            highlightDekNumber: null,
        }
    },
    computed: {
        rateName: function() {
            return this.findRateName(
                this.cabin.apiData.rateName,
                this.cabin.apiData.rateCode
            ).rateName
        },
        cabinFaciliteitenUSPS: function() {
            if (
                this.cabin !== {} &&
                this.cabin.faciliteiten &&
                this.cabin.faciliteiten.usps
            ) {
                return this.cabin.faciliteiten.usps
            }
            return []
        },
    },
    methods: {
        toggleShow: function(val) {
            if (val.detail === '') return false

            if (val.showDetail === true) {
                val.showDetail = false
            } else {
                val.showDetail = true
            }
            if (val.icon === 'plus') {
                val.icon === 'min'
            }
            if (val.icon === 'min') {
                val.icon === 'plus'
            }
        },
        validateIcon: function(icon) {
            if (icon === '') {
                return 'check'
            }
            return icon
        },
        dekstringToArray: function() {
            if (this.cabin.faciliteiten && this.cabin.faciliteiten.dek) {
                let self = this
                let dekStr = self.cabin.faciliteiten.dek
                return dekStr.split(',')
            }
            return null
        },
        matchingServiceCodes: function() {
            if (
                this.cruise &&
                this.cruise.ratecode_usps &&
                this.cruise.ratecode_usps.services &&
                this.cabin.apiData &&
                this.cabin !== {} &&
                this.cabin.apiData !== false &&
                this.cabin.apiData.autoItems
            ) {
                let self = this
                let retAr = []
                self.cruise.ratecode_usps.services.forEach(function(
                    uspsService
                ) {
                    // for each in json data
                    self.cabin.apiData.autoItems.forEach(function(autoItem) {
                        // for each in cabin api data auto items
                        if (
                            uspsService.serviceCode === autoItem.code ||
                            uspsService.serviceCode === autoItem.description
                        ) {
                            // if match
                            uspsService.uspsItems.forEach(function(uspsItem) {
                                // push to array containing uspsItems
                                if (uspsItem.text) {
                                    retAr.push(uspsItem)
                                }
                            })
                        }
                    })
                })
                return retAr
            }
            return []
        },
        matchingRateCodes: function() {
            if (
                this.cruise &&
                this.cruise.ratecode_usps &&
                this.cruise.ratecode_usps.rates &&
                this.cabin.apiData
            ) {
                let rateCode = this.cabin.apiData.rateCode
                let rateName = this.cabin.apiData.rateName

                let found = this.cruise.ratecode_usps.rates.filter(function(
                    usps
                ) {
                    return (
                        (usps.rateCode === rateCode ||
                            usps.rateCode === rateName) &&
                        usps.text !== ''
                    )
                })
                if (!found[0]) {
                    return []
                }
                return found[0].uspsItems
            }
            return []
        },
        buttonText: function(isSelected) {
            if (isSelected) {
                return 'Ga door'
            }
            return 'Selecteren'
        },
        canSelect: function(cabin) {
            if (cabin.apiData) {
                return true
            }
            return false
        },
        doClick: function(cabin) {
            if (this.canSelect(cabin)) {
                this.$emit('selectCabin-click')
            }
        },
        toggleFloorPlan: function() {
            if (this.floorPlanVisible) {
                this.floorPlanVisible = false
            } else {
                this.floorPlanVisible = true
            }
        },
        returnCorrectImage: function() {
            if (this.floorPlanVisible) {
                return this.cabin.img_plattegrond_url
            }
            return this.cabin.img_url
        },
        returnCorrectAction: function() {
            if (this.floorPlanVisible) {
                return 'Hut'
            } else {
                return 'Plattegrond'
            }
        },
    },
}
</script>

<style lang="scss">
.map-icon {
    position: absolute;
    bottom: 5px;
    right: 5px;
    color: #000 !important;
    background-color: #fff;
    padding: 3px 7px;
    border-radius: 3px;
    font-size: 0.7em;
    -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
}

.cabin-banner-chosen {

  background: #f39c13;
  color: white;
  padding: 3px 6px;
  position: absolute;
  top: 10px;
  left: -1px;
  border-radius: 0;
  z-index: 1000;
  font-weight: 600;
}

.cabin-image {
    border-radius: 5px 5px 0 0;
}

.deckNumber {
    cursor: pointer;
}
@media screen and (max-width: 740px) {
  .hidemobileimage {
    display:none;
  }
  .flexcabin.midblock .hidemobileimage + .flexmobile-wrap {
    width:100% !important;
  }
}

</style>
